import { Injector } from "@angular/core";
import { AutoUploadNode } from "../../AutoUploadNode";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { BaseNode } from "../../BaseNode";
import { TreeNodeSourceList } from "../../Art57Node/ListEntity/TreeNodeSourceList";
import { SourceEntity } from "../../../Data/MedicinalProductData/SourceEntity";
import { environment } from "../../../../../../environments/environment";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";


export class SourceAutoUploadEntity extends AutoUploadNode {
    
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any, useHist: boolean, disableAutoUpload: boolean, cloningNode: boolean) {
        const createChildTemplateparams = {nodeType:2};
        super(injector, labelTemplate, SourceEntity, useHist ? AutoUploadEntityEnum.sourceHist : AutoUploadEntityEnum.source, ServiceEnum.MedicinalProducts, parent, model, TreeNodeSourceList, false, disableAutoUpload, cloningNode, createChildTemplateparams);
        this.labelNodeName = 'Source';
        this.useHist = useHist;
      }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: SourceAutoUploadEntity = new SourceAutoUploadEntity(this.ioc!, this.labelTemplate,newParent,this.datasource,this.useHist,this.isLoaded, true);      
      clonedNode.loadEntity();
      clonedNode.isLoading = false;

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }    
}